import { render, staticRenderFns } from "./TheCadastro.vue?vue&type=template&id=4c0f468e&scoped=true"
import script from "./TheCadastro.vue?vue&type=script&lang=js"
export * from "./TheCadastro.vue?vue&type=script&lang=js"
import style0 from "./TheCadastro.vue?vue&type=style&index=0&id=4c0f468e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0f468e",
  null
  
)

export default component.exports